import React, {Component} from 'react';
import Main from '../Main';

class ProductionPlanning extends Component{
    render(){
        return(
            <div>
                <Main/>
                <p>Production planning</p>
            </div>
        )
    }
}

export default ProductionPlanning;
